import {useUserStore} from '@/store/user'
import jwt_decode from 'jwt-decode'

interface DecodedToken {
  loginWizardDone?: string
  redirectTandC?: string
  isUnknownUser?: boolean
  [key: string]: any
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (!process.server) {
    const app = useNuxtApp()
    const userStore = useUserStore()
    const accessToken = userStore.accessToken
    if (accessToken) {
      const decodedToken: DecodedToken = jwt_decode(accessToken)
      if (decodedToken
        && (decodedToken.loginWizardDone === 'false' || decodedToken.redirectTandC === 'true')
        && Object.hasOwn(decodedToken, 'isUnknownUser')
        && Object.hasOwn(decodedToken, 'redirectTandC')) {
        if (to.path === app.$globalization.localePath('/setup')) {
          // if user is already on setup, let him be
          return
        } else {
          return navigateTo(app.$globalization.localePath('/setup'))
        }
      }
    }

    if (to.path === app.$globalization.localePath('/setup')) {
      return navigateTo('/')
    }
  }
})
